/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Physical_ShippingInputs */

const en_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physical Shipping`)
};

const es_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envío físico`)
};

const fr_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expédition physique`)
};

const de_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physischer Versand`)
};

const ja_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品の発送`)
};

const zh_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实物发货`)
};

const ar_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شحن فعلي`)
};

const id_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiriman Fisik`)
};

const it_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spedizione Fisica`)
};

const ru_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Физическая доставка`)
};

const pt_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envio Físico`)
};

const ko_fulfillment_physical_shipping = /** @type {(inputs: Fulfillment_Physical_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실물 배송`)
};

/**
* | output |
* | --- |
* | "Physical Shipping" |
*
* @param {Fulfillment_Physical_ShippingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_physical_shipping = /** @type {((inputs?: Fulfillment_Physical_ShippingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Physical_ShippingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_physical_shipping(inputs)
	if (locale === "es") return es_fulfillment_physical_shipping(inputs)
	if (locale === "fr") return fr_fulfillment_physical_shipping(inputs)
	if (locale === "de") return de_fulfillment_physical_shipping(inputs)
	if (locale === "ja") return ja_fulfillment_physical_shipping(inputs)
	if (locale === "zh") return zh_fulfillment_physical_shipping(inputs)
	if (locale === "ar") return ar_fulfillment_physical_shipping(inputs)
	if (locale === "id") return id_fulfillment_physical_shipping(inputs)
	if (locale === "it") return it_fulfillment_physical_shipping(inputs)
	if (locale === "ru") return ru_fulfillment_physical_shipping(inputs)
	if (locale === "pt") return pt_fulfillment_physical_shipping(inputs)
	return ko_fulfillment_physical_shipping(inputs)
});